import { gql } from './apollo';

export const GET_LATEST_PROMO_REMAINING = gql`
    query ($promo_item_id: MultiTypeInput!) {
        table(
            name: "gc_inventory_promo_item_updates"
            columns: ["new_remaining_inventory"]
            filter: [{ left: "promo_item_id", right: $promo_item_id, expression: "=" }]
            orderBy: "updated_date"
            orderByDirection: DESC
            limit: 1
        )
    }
`;

export const GET_PROMO_UPDATES_FOR_ITEM = gql`
    query ($promo_item_id: MultiTypeInput!) {
        table(
            name: "gc_inventory_promo_item_updates"
            filter: [{ left: "promo_item_id", right: $promo_item_id, expression: "=" }]
            contain: [
                {
                    table: "propertyuser__c"
                    alias: "updated_by_propertyuser__c"
                    columns: ["name"]
                    fk: "id"
                    joinFk: "updated_by"
                    limit: 1
                }
            ]
            orderBy: "updated_date"
            orderByDirection: DESC
            limit: 100
        )
    }
`;

export const CREATE_PROMO_UPDATE = gql`
    mutation (
        $promo_item_id: MultiTypeInput
        $property__c_id: MultiTypeInput
        $new_remaining_inventory: MultiTypeInput
        $remaining_use: MultiTypeInput
        $notes: MultiTypeInput
        $updated_by: MultiTypeInput
        $updated_date: MultiTypeInput
    ) {
        createRow(
            table: "gc_inventory_promo_item_updates"
            values: [
                { property: "promo_item_id", value: $promo_item_id }
                { property: "property__c_id", value: $property__c_id }
                { property: "new_remaining_inventory", value: $new_remaining_inventory }
                { property: "remaining_use", value: $remaining_use }
                { property: "notes", value: $notes }
                { property: "updated_by", value: $updated_by }
                { property: "updated_date", value: $updated_date }
            ]
        )
    }
`;

export const UPDATE_PROMO_ITEM_UPDATE = gql`
    mutation ($id: String!, $new_remaining_inventory: MultiTypeInput) {
        updateRow(
            table: "gc_inventory_promo_item_updates"
            id: $id
            values: [{ property: "new_remaining_inventory", value: $new_remaining_inventory }]
        )
    }
`;
